import ns from '../api/utilities/namespace.js';

export const CollapseSelector = {
  COLLAPSE: ns.selector('collapse')
};
